import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSCountryParams,
  CMSImageBase,
  CMSScheduler,
  getResponseCMS,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';
import { isCMSV3 } from '@/helpers/conf';

export interface CMSGameTheme
  extends CMSApiBase,
    CMSScheduler,
    CMSCountryParams {
  categoryId: string;
  title: string;
  order: number;
  icon: CMSImageBase;
}

export const gameThemesCMSV3 = (lang: string) => {
  return request<CMSGameTheme[]>({
    url: buildCmsUrl({ path: 'game-themes', lang }),
  });
};

export const gameThemesCMSV4 = (lang: string) => {
  return request<CMSGameTheme[]>({
    url: buildCmsUrl({
      path: 'game-themes',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<CMSGameTheme[]>
    ),
  });
};

export const gameThemesCMS = isCMSV3 ? gameThemesCMSV3 : gameThemesCMSV4;
